if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      this.handleBodyClick = this.handleBodyClick.bind(this);
      this.handleKeyUp = this.handleKeyUp.bind(this);
    }

    connectedCallback() {
      this.cartIcon = document.getElementById('cart-icon-bubble');

      if (this.cartIcon && !this.cartIcon.hasAttribute('data-cart-drawer-bound')) {
        this.cartIcon.setAttribute('role', 'button');
        this.cartIcon.setAttribute('aria-haspopup', 'dialog');
        this.cartIcon.setAttribute('data-cart-drawer-bound', 'true');

        this.cartIcon.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(this.cartIcon);
        });

        this.cartIcon.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() !== 'SPACE') return;
          event.preventDefault();
          this.open(this.cartIcon);
        });
      }

      this.addEventListener('click', this.handleBodyClick);
      this.addEventListener('keyup', this.handleKeyUp);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleBodyClick);
      this.removeEventListener('keyup', this.handleKeyUp);
    }

    handleBodyClick(event) {
      if (event.target.id === 'CartDrawer-Overlay') {
        this.close();
      }
    }

    handleKeyUp(event) {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.close();
      }
    }

    open(triggeredBy = null) {
      if (triggeredBy) this.setActiveElement(triggeredBy);

      const drawerInner = this.querySelector('.drawer__inner');
      const focusContainer = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__inner-empty') || drawerInner
        : drawerInner;
      const focusTarget = focusContainer ? getFocusableElements(focusContainer)[0] || focusContainer : this;

      this.classList.add('active');
      document.body.classList.add('overflow-hidden');

      if (drawerInner) {
        drawerInner.addEventListener(
          'transitionend',
          () => {
            trapFocus(focusContainer || this, focusTarget);
          },
          { once: true }
        );
      } else {
        trapFocus(focusContainer || this, focusTarget);
      }
    }

    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.activeElement);
    }

    renderContents(parsedState) {
      this.classList.toggle('is-empty', parsedState.item_count === 0);

      this.getSectionsToRender().forEach((section) => {
        const sectionHtml = parsedState.sections[section.id];
        if (!sectionHtml) return;

        const target =
          section.id === 'cart-drawer'
            ? this.querySelector(section.selector)
            : document.getElementById(section.id);

        if (!target) return;

        target.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
      });

      this.open();
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}

if (!customElements.get('cart-drawer-items')) {
  customElements.define(
    'cart-drawer-items',
    class CartDrawerItems extends CartItems {}
  );
}
